import React, { Component } from 'react'
import { Field, reduxForm, FormSection, FieldArray } from 'redux-form'
import { Link, browserHistory } from 'react-router'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import cookie from 'react-cookie'
import * as actions from '../../actions'
import InputProfile from '../componentKit2/InputProfile'
import CheckboxOfert from '../componentKit/CheckboxOfert'
import RadioProfile from '../componentKit/RadioProfile'

import SelectComponent from '../componentKit/SelectComponent'

import { api, host, domen } from '../../config.js'
import CSSModules from 'react-css-modules'
import styles from './signupValidationForm.css'
import {cities, citiesUnipro} from '../../utils/data'

let contentStyle = {
  borderRadius: '18px',
  padding: '30px'
}

const FB = window.FB



class SignupValidationForm extends Component {

  state = {
    users: [1]
  }

  componentWillMount() {
    if (window.mobilecheck()) {
      contentStyle.width = '300px'
    }
  }

  componentDidMount() {
    const { change, email, card, keyCard, code, service } = this.props

    if (email) {
      change('email', email)
    }

    document.addEventListener('DOMContentLoaded', function () {
      window.addEventListener('message', function (event) {
        if (event.data.name === 'okAuth') {
          browserHistory.push({ pathname: '/social/ok', query: { code: event.data.code } })
        }
      }, false)
    }, false)

  }

  addUser = () => {
    const users = this.state.users;
    this.setState({
      users: users.concat(users.length + 1),
    })
  }

  render() {
    const { errorsValidate, handleSubmit, sign, packageType, program, onSubmit, promo, isTest, serviceIsFamily } = this.props
    const { host, isSimpleRegs } = sign

    const isAlfa = domen.isAlfa
    const isTele2Lk = domen.isTele2
    const isUnipro = domen.isUnipro

    const loginVk = () => {
      if (packageType) {
        cookie.save('packageType', packageType, { path: '/', maxAge: 60 * 60 * 24 * 365 * 10 })
      }
      if (program) {
        cookie.save('program', program, { path: '/', maxAge: 60 * 60 * 24 * 365 * 10 })
      }
      if (promo) {
        cookie.save('promoName', promo, { path: '/', maxAge: 60 * 60 * 24 * 365 * 10 })
      }

      window.location = `https://oauth.vk.com/authorize?client_id=5750682&scope=offline&redirect_uri=${host}/social/vk&display=page&response_type=code`
    }

    const loginOk = () => {
      if (packageType) {
        cookie.save('packageType', packageType, { path: '/', maxAge: 60 * 60 * 24 * 365 * 10 })
      }
      if (program) {
        cookie.save('program', program, { path: '/', maxAge: 60 * 60 * 24 * 365 * 10 })
      }
      if (promo) {
        cookie.save('promoName', promo, { path: '/', maxAge: 60 * 60 * 24 * 365 * 10 })
      }

      const url = `https://connect.ok.ru/oauth/authorize?client_id=1248995328&scope=VALUABLE_ACCESS,LONG_ACCESS_TOKEN,PHOTO_CONTENT,GET_EMAIL&response_type=code&redirect_uri=${host}/social/ok`
      window.open(url, 'Odnoklassniki', 'width=700,height=400')
    }

    const redirectFb = () => {
      let uri

      if (program) {
        uri = encodeURI(`${host}/social/fb?type=${packageType},${program},${promo}`)
      } else {
        uri = encodeURI(`${host}/social/fb`)
      }

      window.location = encodeURI('https://www.facebook.com/dialog/oauth?client_id=602675109923486&redirect_uri=' + uri + '&response_type=token')
    }

    const loginFb = () => {
      const self = this
      FB.getLoginStatus(function(response) {
        if (response.status === 'connected') {
          const token = response.authResponse.accessToken
          const userId = response.authResponse.userID
          const payload = { userId, token }
          return fetch(`${api}/user/authenticate-social`, {
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            },
            method: 'POST',
            body: JSON.stringify(payload)
          })
          .then(response => response.json())
          .then(json => {
            if (json.errorCode === 1 && json.data && json.data.authToken) {
              cookie.save('token', json.data.authToken, { path: '/', maxAge: 60 * 60 * 24 * 365 * 10 })
              self.props.setToken(json.data.authToken)
              browserHistory.push('/signup/pay')
            } else {
              redirectFb()
            }
          })
        } else {
          redirectFb()
        }
      }, { scope: 'email' })
    }

    return (

      <form  onSubmit={handleSubmit(onSubmit)} className={styles.entryBox}>
        <FieldArray
          name="users"
          component={renderUsers}
          isTest={isTest}
          isTele2Lk={isTele2Lk}
          serviceIsFamily={serviceIsFamily}
          errorsValidate={errorsValidate}
        />

        <hr className="gender__hr"/>

        <div className={styles.checkboxes}>
          <Field checked={isTest ? true : false} name='accept' title='Принять условия ' id='accept'  isTest ={isTest} component={CheckboxOfert} />
        </div>


       {/* {error && <strong>{error}</strong>}*/}

        <button type='submit' className={isTest ? styles.buttonActionWide : isTele2Lk ? styles.buttonTele2Wide : styles.buttonSecondaryWide}>
          {!isTest ? 'Зарегистрироваться' : 'Зарегистрироваться и получить подарок'}
        </button>

        {/*{ isTest ?
          <div className={styles.checkboxes}>
            <Field
              checked ={true}
              name='accept'
              title='Принять условия '
              id='accept'
              isTest ={isTest}
              component={CheckboxOfert} />
          </div>
          : null }*/}


        <hr className="gender__down"/>

        <ul className="entry-nav mtb20">
          <li className={styles.entryNavItem}>
            <Link className={styles.entryNavLink}to="/">Вход в кабинет</Link>
          </li>
          <li className={styles.entryNavItem}>
            <Link className={styles.entryNavLink} to="/restore">Забыли пароль?</Link>
          </li>
        </ul>

        {/* <p className={styles.textCenterMb10}>Войти через социальные сети</p>

        <ul className={styles.socialSignin}>
          <li className={styles.socialSigninItemFb} onClick={loginFb}>
            <svg className={styles.svgIcoFb}>
              <use xlinkHref="#fb"></use>
            </svg>
          </li>
          <li className={styles.socialSigninItemVk} onClick={loginVk}>
            <svg className={styles.svgIcoVk}>
              <use xlinkHref="#vk"></use>
            </svg>
          </li>
          <li className={styles.socialSigninItemOk} onClick={loginOk}>
            <svg className={styles.svgIcoOk}>
              <use xlinkHref="#odnoklassniki"></use>
            </svg>
          </li>
        </ul> */}
      </form>
    )
  }
}

const validate = data => {
  let errors = {}

  if (!data.users|| !data.users.length) {
    errors.users = { _error: 'At least one member must be entered' }
  } else {
    const userArrayErrors = [];
    data.users.forEach((user, userIndex) => {
      const userErrors = {};
      if (user.email) {
        user.email = user.email.replace(/ /g, '');
        let email = user.email.split('@');

        if (domen.isTele2 && email[1] !== 'tele2.ru' && user.email !== 'muhanov@list.ru') {
          //errors.email = 'Почта должна быть в домене @tele2.ru '
          userErrors.firstName = 'Почта должна быть в домене @tele2.ru ';
          userArrayErrors[userIndex] = userErrors;
        }
      }


			if (!user.workCard) {
				userErrors.workCard = 'ID партнера должно быть заполнено';
				userArrayErrors[userIndex] = userErrors;
			}
			if (user.workCard && (user.workCard.length < 6 || user.workCard.length > 6)) {
				userErrors.workCard = 'Поле должно состоять из 6 цифр.';
				userArrayErrors[userIndex] = userErrors;
			}

			if(user.workCard && !/^\d+$/i.test(user.workCard)){
				userErrors.workCard = 'Поле должно состоить только из цифр.';
				userArrayErrors[userIndex] = userErrors;
      }

      switch (true) {
        case !user.email:
          //errors.email = 'Email должен быть заполнен'
          userErrors.email = 'Email должен быть заполнен';
          userArrayErrors[userIndex] = userErrors;
          break;
        case !/^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i.test(user.email):
          //errors.email = 'Email заполнен неправильно, проверьте его еще раз'
          userErrors.email = 'Email заполнен неправильно, проверьте его еще раз';
          userArrayErrors[userIndex] = userErrors;
          break;
        default:
          break
      }

      switch (true) {
        case !user.password:
          //errors.password = 'Поле пароля должно быть заполнено'
          userErrors.password = 'Поле пароля должно быть заполнено';
          userArrayErrors[userIndex] = userErrors;
          break;
        case user.password.length < 6:
          //errors.password = 'Поле пароля должно быть длиннее 6 символов'
          userErrors.password = 'Поле пароля должно быть длиннее 6 символов';
          userArrayErrors[userIndex] = userErrors;
          break;
        case user.password.length > 20:
          //errors.password = 'Поле пароля должно быть короче 20 символов'
          userErrors.password = 'Поле пароля должно быть короче 20 символов';
          userArrayErrors[userIndex] = userErrors;
          break;
        case /["]/g.test(user.password):
          //errors.password = 'Поле пароля не должно содержать знак "'
          userErrors.password = 'Поле пароля не должно содержать знак "';
          userArrayErrors[userIndex] = userErrors;
          break;
        default:
          break
      }

      if (user.password !== user.passwordAgain) {
        //errors.passwordAgain = 'Пароли должны совпадать'
        userErrors.passwordAgain = 'Пароли должны совпадать';
        userArrayErrors[userIndex] = userErrors;
      }

      if (!user.gender) {
        //errors.gender = 'Пол должен быть заполнен'
        userErrors.gender = 'Пол должен быть заполнен';
        userArrayErrors[userIndex] = userErrors;
      }
    });

    if (userArrayErrors.length) {
      errors.users = userArrayErrors;
    }

  }

  if (!data.accept) {
    errors.accept = 'Вы должны принять условия оферты и правил'
  }
  return errors
}

const asyncValidate = values => {
  return fetch(`${api}/user/user-check`, {
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    method: 'POST',
    body: JSON.stringify({ email: values.email })
  })
  .then(response => response.json())
  .then(json => {

    if (json.data) {
      throw { email: 'Такой email уже существует' }
    }
  })
}

SignupValidationForm = reduxForm({
  form: 'signupFormValidation',
  validate,
  //asyncValidate,
  //asyncBlurFields: [ 'email' ]
})(SignupValidationForm)

const mapStateToProps = state => {
  const {sign, errorsValidate} = state
  let { program, packageType, promo } = state.profile

  return {
    program,
    errorsValidate,
    sign,
    packageType,
    promo
  }
}

const mapDispatchToProps = dispatch => ({
  setToken: bindActionCreators(actions.setToken, dispatch)
})

SignupValidationForm = connect(
  mapStateToProps,
  mapDispatchToProps
)(SignupValidationForm)

export default CSSModules(SignupValidationForm, styles)


class renderUsers extends Component {

  componentDidMount(){
    this.props.fields.push({})
  }

  removeUser = (index) => {
    this.props.fields.remove(index)
  }
  render(){
    const { fields, isTest, isTele2Lk, serviceIsFamily, errorsValidate } = this.props;
    return(
      <div>
        {
          fields.map((user, index) => {
            return (
              <div className={styles.user} key={index}>

                {index !== 0 && <hr className={styles.hrUser}/>}

                { index !== 0 &&
                  <div className={styles.userClose} onClick={() => this.removeUser(index)}>
                    Удалить участника
                </div>
                }

                {
                  serviceIsFamily &&
                  <div className="gender__title">{`Участник ${index +1}`}</div>
                }

                {isTest ?
                  <div>
                    <div className={styles.errorGender}>{errorsValidate.error}</div>
                    <div className={styles.genderAuth}>
                      <p className="gender__title">Ваш пол:</p>
                      <Field  name={`${user}.gender`} value="male" type='radio' title="Мужчина" id="gender[1]"
                             component={RadioProfile}/>
                      <Field  name={`${user}.gender`} value="female" type='radio' title="Женщина" id="gender[2]"
                             component={RadioProfile}/>
                    </div>
                  </div>
                  : null
                }

								<Field name={`${user}.workCard`} id='workCard' placeholder='ID партнера' type='text' component={InputProfile}/>

                <div className={styles.input}>
                  <Field name={`${user}.email`} id='login[1]' placeholder='Ваш e-mail' component={InputProfile}/>
                  {isTele2Lk ?
                    <div data-tooltip="Регистрация с корпортивной почты в домене @tele2.ru" className={styles.inputIco}>
                      <svg className={styles.svgIconFormHelp}>
                        <use xlinkHref="#ico-form-help"></use>
                      </svg>
                    </div>
                    : null}
                </div>

                <Field name={`${user}.password`} id='login[2]' placeholder='Ваш пароль' type='password' component={InputProfile}/>
                <Field name={`${user}.passwordAgain`} id='login[3]' placeholder='Пароль повторно' type='password'
                       component={InputProfile}/>

                {/*    {isUnipro && !isSimpleRegs &&
            <div className={styles.input}>
              <Field notReq={true} name='workTeam' id='workTeam' placeholder='Ваша команда' component={InputProfile} />
              <div data-tooltip="Это поле заполняется, если вы участвуете в составе команды из 5 участников. Это поле вы сможете заполнить в личном кабинете после его активации 7 мая" className={styles.inputIco}>
                <svg className={styles.svgIconFormHelp}>
                  <use xlinkHref="#ico-form-help"></use>
                </svg>
              </div>
            </div>

        }*/}

                {/* { isUnipro &&
          <div>
            <div className={styles.errorGender}>{errorsValidate.errorYou}</div>
            <div className={styles.genderAuth}>
              <p className="gender__title">Вы:</p>
              <Field notError={true} name="workRelation" value="relative" type='radio' title="Родственник" id="workRelation[1]" component={RadioProfile} />
              <Field notError={true} name="workRelation" value="worker" type='radio' title="Сотрудник" id="workRelation[2]" component={RadioProfile} />
            </div>
            <hr className="gender__hr"/>
          </div>
          }*/}

                {/*  {isTele2Lk || isUnipro &&
            <div className="select">
              <Field
                name='city'
                id='city'
                placeholder='Ваш город'
                options={isUnipro ? citiesUnipro : cities}
                component={SelectComponent}
              />
            </div>
        }*/}

                {!isTest ?
                  <div>
                    <div className={styles.errorGender}>{errorsValidate.error}</div>
                    <div className={styles.genderAuth}>
                      <p className="gender__title">Ваш пол:</p>
                      <Field name={`${user}.gender`} value="male" type='radio' title="Мужчина" id={`gender-${user}-1`}
                             component={RadioProfile}/>
                      <Field notError={true} name={`${user}.gender`} value="female" type='radio' title="Женщина" id={`gender-${user}-2`}
                             component={RadioProfile}/>
                    </div>
                  </div>
                  : null
                }
              </div>
            )
          })
        }

        {
          serviceIsFamily  && fields.getAll() && fields.getAll().length < 3 &&
          <button
            className={styles.buttonActionWide}
            onClick={() => fields.push({})}
            type='button'
          >
            Добавить участника
          </button>
        }
      </div>

    )
  }
}



// WEBPACK FOOTER //
// /var/www/build-health-2/src/components/profile/SignupValidationForm.js